// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBUVS14SqKAXUtpbC0Hojb5kjjlzsKV0Ms",
    authDomain: "anxiety-tracker-c83eb.firebaseapp.com",
    projectId: "anxiety-tracker-c83eb",
    storageBucket: "anxiety-tracker-c83eb.appspot.com",
    messagingSenderId: "930678131561",
    appId: "1:930678131561:web:509de1ef796a5a2607cbf8",
    measurementId: "G-K9MYGP74MJ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
